import request from '@/utils/request';

export function createActualization(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/store',
        method: 'post',
        data,
    });
}

export function deleteActualization(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/delete',
        method: 'post',
        data,
    });
}

export function confirmActualization(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/confirm',
        method: 'post',
        data,
    });
}

export function confirmActualizationMultiple(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/confirm-multiple',
        method: 'post',
        data,
    });
}

export function saveCalendar(data) {
    return request({
        url: 'https://viaglobal.pl/api//calendar',
        method: 'post',
        data,
    });
}

export function saveBonuses(data) {
    return request({
        url: 'https://viaglobal.pl/api//bonuses',
        method: 'post',
        data,
    });
}

export function fetchList(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/index',
        method: 'get',
        params: data,
    });
}

export function sendMessage(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/message',
        method: 'post',
        data,
    });
}
